import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useLang, t } from "@/lib/i18n";

const SECTIONS = [
  ["privacyControllerTitle", "privacyControllerBody"],
  ["privacyPurposeTitle", "privacyPurposeBody"],
  ["privacyCookieTitle", "privacyCookieBody"],
  ["privacyRightsTitle", "privacyRightsBody"],
];

export default function PrivacyPolicyLink() {
  const [open, setOpen] = useState(false);
  const lang = useLang();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <button
        data-testid="privacy-link"
        onClick={() => setOpen(true)}
        className="text-[11px] tracking-widest uppercase text-[#8A837C] hover:text-[#C5A059] underline underline-offset-4 decoration-[#C5A059]/40 transition-colors"
      >
        {t(lang, "privacyLink")}
      </button>

      {open && (
        <div
          data-testid="privacy-modal"
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-[#1C1B1A]/60 backdrop-blur-sm p-0 sm:p-6"
          onClick={() => setOpen(false)}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-label={t(lang, "privacyTitle")}
            className="w-full sm:max-w-lg bg-[#FAF7F2] border border-[#C5A059]/40 rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[85vh] flex flex-col animate-fade-up"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-[#E8DFC9]">
              <h2 className="font-display font-semibold text-2xl text-[#6B1724]">{t(lang, "privacyTitle")}</h2>
              <button
                data-testid="privacy-close-icon"
                onClick={() => setOpen(false)}
                aria-label={t(lang, "privacyClose")}
                className="text-[#8A837C] hover:text-[#6B1724] transition-colors p-1"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="overflow-y-auto px-6 py-5 space-y-5 flex-1">
              {SECTIONS.map(([titleKey, bodyKey]) => (
                <section key={titleKey}>
                  <h3 className="font-cinzel text-[11px] tracking-[0.22em] uppercase text-[#8B1E32] flex items-center gap-2 mb-1.5">
                    <span className="h-1 w-1 rotate-45 bg-[#C5A059] shrink-0" aria-hidden="true" />
                    {t(lang, titleKey)}
                  </h3>
                  <p className="text-sm text-[#5C5652] leading-relaxed">{t(lang, bodyKey)}</p>
                </section>
              ))}
            </div>
            <div className="px-6 py-4 border-t border-[#E8DFC9]">
              <button
                data-testid="privacy-close-button"
                onClick={() => setOpen(false)}
                className="w-full rounded-full bg-gradient-to-br from-[#7A1C2E] to-[#54101A] text-[#EED8A1] font-cinzel text-xs tracking-[0.2em] uppercase py-3 border border-[#C5A059]/60 hover:shadow-lg transition-shadow"
              >
                {t(lang, "privacyClose")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
